import { ChangeDetectionStrategy, Component, ViewEncapsulation, computed, input } from '@angular/core';
import { TextStyleColor, TextStyleVariant } from '@sirius/typography';

import { TextHtmlComponent } from './text-html.component';
import { ITextHtml } from '../_shared/models/text/text-html.model';

@Component({
    selector: 'sirius-text-html-blog',
    template: `
        <sirius-text-html
            [html]="resolvedHtml()"
            [itemprop]="resolvedItemprop()"
            textStyleSize="l"
            [textStyleVariant]="textStyleVariant()"
            [textStyleColor]="textStyleColor()"></sirius-text-html>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    imports: [TextHtmlComponent]
})
/** @deprecated Use `sirius-text-html` directly. */
export class TextHtmlBlogComponent {
    readonly config = input<ITextHtml | undefined>();

    readonly html = input('');
    readonly itemprop = input<string | undefined>();
    readonly textStyleVariant = input<TextStyleVariant>('default');
    readonly textStyleColor = input<TextStyleColor>('primary');

    readonly resolvedItemprop = computed(() => this.config()?.itemprop ?? this.itemprop());
    readonly resolvedHtml = computed(() => this.config()?.html ?? this.html());
}
